/**
 * modify-user-metadata-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class ModifyUserMetadataRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_EDIT_USER;
	public static tag : MessageTag = MessageTag.REQ_EDIT_USER;

  constructor (public objectId : number)
  {
    super();
    throw new Error("This message is reserved but unimplemented.");
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/group-management/modify-user-metadata-request.ts